import styled, { css } from 'styled-components';

type TContainerProps = {
  transparent?: boolean;
};

export const Container = styled.div<TContainerProps>`
  ${({ theme, transparent }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.layout.spacing(2)};

    padding: ${theme.layout.spacing(3)};

    background: ${transparent ? 'none' : theme.palette.neutral[100]};
    border-radius: 1.5rem;
  `}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    width: 2rem;
    min-width: 2rem;
    height: 2rem;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: ${theme.palette.primary.main};
      font-size: 2rem;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.spacing(0.7)};
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.palette.primary.main};

    font-size: ${theme.typography.sizes.body2};
    font-weight: ${theme.typography.weight.bold};
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.palette.text.main};

    font-size: ${theme.typography.sizes.caption};
    font-weight: ${theme.typography.weight.light};
  `}
`;
